<template>
    <div class="change-record-dialog">
        <el-dialog :title="$t('Sell.Charge.history')" :visible.sync="visible" left>
            <div class="mb-5" v-if="activeName==='member' || activeName === 'personal'">
                <el-button
                    @click="fetchData(1)"
                    :class="ischecked === 1 ? 'blue' : 'white'"
                    class="mr-5"
                    type="primary" plain>{{ $t('Sell.Dialog.info_change') }}</el-button>
                <el-button
                    @click="fetchData(2)"
                    :class="ischecked === 2 ? 'blue' : 'white'"
                    class="mr-5"
                    type="primary" plain>{{ $t('Common.lesson') }}</el-button>
                <el-button
                    @click="fetchData(3)"
                    :class="ischecked === 3 ? 'blue' : 'white'"
                    class="mr-5"
                    type="primary" plain>{{ $t('Reception.First.sign') }}</el-button>
                <el-button
                    @click="fetchData(4)"
                    :class="ischecked === 4 ? 'blue' : 'white'"
                    type="primary"
                    plain>{{ $t('Sell.remark') }}</el-button>
            </div>
            <div class="mb-5" v-if="activeName==='cardsCon'">
                <el-button
                    @click="fetchData(1)"
                    :class="ischecked === 1 ? 'blue' : 'white'"
                    class="mr-5"
                    type="primary" plain>{{ $t('Sell.Dialog.info_change') }}</el-button>
                <el-button
                    @click="fetchData(6)"
                    :class="ischecked === 6 ? 'blue' : 'white'"
                    class="mr-5"
                    type="primary" plain>{{ $t('Sell.Pay.consumption') }}</el-button>
                <el-button
                    @click="fetchData(4)"
                    :class="ischecked === 4 ? 'blue' : 'white'"
                    type="primary"
                    plain>{{ $t('Sell.remark') }}</el-button>
            </div>
            <div class="mb-5" v-if="activeName==='deposit'">
                <el-button
                    @click="fetchData(1)"
                    :class="ischecked === 1 ? 'blue' : 'white'"
                    class="mr-5"
                    type="primary"
                    plain>{{ $t('Sell.Dialog.info_change') }}</el-button>
            </div>
            <el-table :data="tableData" border style="width: 100%;">
                <el-table-column prop="createdAt" :label="$t('Common.time')" width="150px"/>
                <el-table-column prop="remark" :label="$t('Sell.Charge.charge')"/>
                <el-table-column prop="operatorNickname" :label="$t('Reception.Third.people')" width="150px"/>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import { Dialog, Button, ButtonGroup } from 'element-ui';

export default {
    props: ['activeName'],
    components: {
        ElDialog: Dialog,
        ElButton: Button,
        ElButtonGroup: ButtonGroup,
    },
    data() {
        return {
            contractNum: '',
            loading: false,
            visible: false,
            tableData: [],
            ischecked: null,
        };
    },
    watch: {},
    methods: {
        open(data) {
            this.contractNum = data;
            this.fetchData(1);
        },
        fetchData(data) {
            this.ischecked = data;
            this.loading = true;
            let url;
            if (this.activeName === 'deposit') url = `contract/deposit/${this.contractNum}/change-record`;
            else url = `contract/common/${this.contractNum}/change-record`;
            API.get(url, {
                params: {
                    recordType: data,
                },
            }).then(res => {
                this.tableData = res;
                this.visible = true;
            }).catch(err => {
                $ele.$message.error(err);
            });
        },
    },
};

</script>
<style lang="scss">
.change-record-dialog {
    .el-dialog {
        width: 55%;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-height: 521px;
        overflow-y: auto;
    }
    .el-dialog__title {
        font-size: 16px;
    }
    .el-dialog__header {
        line-height: 40px;
        background-color: #f2f2f2;
        border-bottom: 1px solid #e6e6e6;
        font-size: 14px;
        color: #333;
        text-align: left;
        padding: 0 45px 0 15px;
    }
    .blue {
        color: #fff;
        background-color: #409EFF;
        border-color: #409EFF;
    }
    .white {
        color: #409EFF;
        background: #ecf5ff;
        border-color: #b3d8ff;
    }
}
</style>
